export enum SimulationType {
  INDIVIDUAL = 'INDIVIDUAL',
  MANAGER = 'MANAGER',
}
